import { LineRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathLinePicker, MathPickerContribution } from "../constants";

import { DefaultMathLinePicker } from "./line-picker";

let loadLinePick = !1;

export function bindLineMathPickerContribution(container) {
    loadLinePick || (loadLinePick = !0, container.bind(MathLinePicker).toDynamicValue((() => new DefaultMathLinePicker(resolveContainerBinding(container, LineRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathLinePicker));
}
//# sourceMappingURL=line-module.js.map
